import BeveledBoxSvg317x89 from './BeveledBoxSvg317x89';

export default BeveledBoxSvg317x89;
export { BeveledBoxSvg317x89 };
